function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#4038FF",
  fill: "#4038FF",
  strokeLinecap: "square",
  d: "M20 22V8l-6-6H4v20z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M14 1v7h7m-5 5H8m8 4H8"
}));

var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZyBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjNDAzOEZGIiBmaWxsPSIjNDAzOEZGIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBkPSJNMjAgMjJWOGwtNi02SDR2MjB6Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjRkZGIiBkPSJNMTQgMXY3aDdNMTYgMTNIOE0xNiAxN0g4Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgDocument as ReactComponent };